import { db } from "../firebase";
import {
doc,
setDoc,
getDoc,
updateDoc,
collection,
query,
where,
getDocs,
} from "firebase/firestore";

/* ---------------- CREATE USER PROFILE ---------------- */
export const createUserProfile = async (uid, userData) => {
try {
const userRef = doc(db, "users", uid);


await setDoc(userRef, {
  uid,
  email: userData.email,
  firstName: userData.firstName,
  lastName: userData.lastName,
  displayName:
    userData.displayName ||
    `${userData.firstName} ${userData.lastName}`,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  cart: [], // initialize empty cart
});

return true;


} catch (error) {
console.error("Error creating user profile:", error);
throw error;
}
};

/* ---------------- GET USER PROFILE ---------------- */
/* ---------------- GET USER PROFILE ---------------- */
export const getUserProfile = async (uid) => {
  try {
    const userRef = doc(db, "users", uid);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      return userSnap.data(); // return profile data
    } else {
      console.log("User profile not found");
      return null;
    }

  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

/* ---------------- UPDATE USER PROFILE ---------------- */
export const updateUserProfile = async (uid, userData) => {
try {
const userRef = doc(db, "users", uid);


await updateDoc(userRef, {
  ...userData,
  updatedAt: new Date().toISOString(),
});

return true;


} catch (error) {
console.error("Error updating user profile:", error);
throw error;
}
};

/* ---------------- CHECK EMAIL EXISTS ---------------- */
export const checkEmailExists = async (email) => {
try {
const q = query(
collection(db, "users"),
where("email", "==", email)
);


const querySnapshot = await getDocs(q);

return !querySnapshot.empty;


} catch (error) {
console.error("Error checking email:", error);
throw error;
}
};

/* ---------------- SAVE USER CART ---------------- */
export const saveUserCart = async (uid, cartItems) => {
try {
const userRef = doc(db, "users", uid);


await setDoc(
  userRef,
  {
    cart: cartItems,
    cartUpdatedAt: new Date().toISOString(),
  },
  { merge: true } // important: prevents overwriting user data
);

return true;


} catch (error) {
console.error("Error saving cart:", error);
throw error;
}
};

/* ---------------- GET USER CART ---------------- */
export const getUserCart = async (uid) => {
try {
const userRef = doc(db, "users", uid);


const userSnap = await getDoc(userRef);

if (userSnap.exists()) {
  const data = userSnap.data();
  return data.cart || [];
}

return [];


} catch (error) {
console.error("Error fetching cart:", error);
return [];
}
};
